var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1782",
    d: "M0-682.665H17.5v17.5H0Z",
    transform: "translate(0 682.665)",
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41266",
    "data-name": "Group 41266",
    transform: "translate(-538 -218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15661",
    "data-name": "Rectangle 15661",
    width: 20,
    height: 20,
    transform: "translate(538 218)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-group",
    transform: "translate(539.25 219.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1780",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1786",
    transform: "translate(6.562 10.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1788",
    d: "M-93.539-18.322A6.493,6.493,0,0,0-96-18.8v1.367a5.129,5.129,0,0,1,2.461.625Z",
    transform: "translate(96 18.804)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1790",
    transform: "translate(10.972 6.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1792",
    d: "M-199.92-100.035a6.493,6.493,0,0,0-5.26-2.632v1.333a5.14,5.14,0,0,1,3.419,1.3Z",
    transform: "translate(205.179 102.666)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41263",
    "data-name": "Group 41263",
    transform: "translate(11.074 11.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1794",
    transform: "translate(2.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1796",
    d: "M0,0V5.742",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1798",
    transform: "translate(0 2.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1800",
    d: "M0,0H5.742",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1802",
    transform: "translate(3.281 5.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1804",
    d: "M0-120.821A3.179,3.179,0,0,1,3.179-124a3.179,3.179,0,0,1,3.179,3.179,3.179,3.179,0,0,1-3.179,3.179A3.179,3.179,0,0,1,0-120.821Z",
    transform: "translate(0 124)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1806",
    transform: "translate(0.684 11.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1808",
    d: "M0-222.155A5.845,5.845,0,0,1,5.845-228",
    transform: "translate(0 227.999)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1810",
    transform: "translate(7.793 0.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1812",
    d: "M0-120.491a3.17,3.17,0,0,1,3.17-3.17,3.17,3.17,0,0,1,3.17,3.17,3.17,3.17,0,0,1-3.17,3.17A3.17,3.17,0,0,1,0-120.491Z",
    transform: "translate(0 123.661)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroup);
export default __webpack_public_path__ + "static/media/add-group.ab38fd721bc4eb1fe13560c705f8eeb9.svg";
export { ForwardRef as ReactComponent };